module.exports = __webpack_public_path__ + "static/img/hurix.8d61073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hurix.png
// module id = ZTh9
// module chunks = 36